// import ReactDOM from 'react-dom/client';
import Box from "@mui/material/Box";
import ArrowRight from "assets/images/arrow-right.png";
import CircularProgress from "@mui/material/CircularProgress";
import { useState } from 'react';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';

import "./index.scss";

const MenuDrawer = ({onInput, loading=false}) => {
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen((pre) => !pre);
    };

    const handleClickAway = () => {
        setOpen(false);
    };

    const handleItemClick = (e, item) => {
        e.stopPropagation();
        onInput(item);
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <Box className={`menu-drawer-component ${open ? 'active' : ''}`}>
                <Box className="action-box" onClick={handleClick}>
                    <span>Project setting</span>
                    {loading ? <CircularProgress size={30} color="inherit" /> : <img src={ArrowRight} alt="Arrow Right" />}
                    
                </Box>
                <Box className="drawer-box">
                    <Box className="line"></Box>
                    <Box className="items">

                        <Box className="item" onClick={(e) => handleItemClick(e, 'create')}>
                            Create project
                        </Box>
                        <Box className="item" onClick={(e) => handleItemClick(e, 'close')}>
                            Close tab
                        </Box>
                    </Box>
                </Box>
            </Box>
        </ClickAwayListener>
    );
};

export default MenuDrawer;
